(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // Observe only this snippet's lazy images.
      this.images.forEach((img) => {
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGImageLazyLoader is unavailable, falling back to direct image loading.');
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        close: this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        body: document.body,
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`);
      this.classList.add(`${popupClass}`);
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.pauseVideoClick = this.pauseVideo.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.videoMediaQuery = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    get isMobileViewport() {
      return this.videoMediaQuery ? this.videoMediaQuery.matches : false;
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', this.pauseVideoClick);
      this.addVideoMediaQueryListener();
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    disconnectedCallback() {
      this.playVideoButton?.removeEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.removeEventListener('click', this.pauseVideoClick);
      this.removeVideoMediaQueryListener();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.getCurrentVideoTemplate(),
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState('play');
      if (!this.videoContainer || !this.hasCurrentVideoVariant(this.videoContainer)) {
        this.videoContainer?.remove();
        this.appendCurrentVideoContainer();
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach((video) => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (video.duration && video.currentTime >= video.duration && this.loop == 'false') {
              this.pauseVideo();
              this.switcherVideoButtonState('pause');
            }
          });
        });
      }
    }

    addVideoMediaQueryListener() {
      if (!this.videoMediaQuery || this.isVideoMediaQueryListenerAdded) return;

      if (this.videoMediaQuery.addEventListener) {
        this.videoMediaQuery.addEventListener('change', this.handleViewportChange);
      } else {
        this.videoMediaQuery.addListener(this.handleViewportChange);
      }

      this.isVideoMediaQueryListenerAdded = true;
    }

    removeVideoMediaQueryListener() {
      if (!this.videoMediaQuery || !this.isVideoMediaQueryListenerAdded) return;

      if (this.videoMediaQuery.removeEventListener) {
        this.videoMediaQuery.removeEventListener('change', this.handleViewportChange);
      } else {
        this.videoMediaQuery.removeListener(this.handleViewportChange);
      }

      this.isVideoMediaQueryListenerAdded = false;
    }

    handleViewportChange() {
      if (!this.videoContainer) return;

      const shouldKeepContainerClosed = this.videoContainer.classList.contains('close');
      const shouldResumeVideo = this.isCurrentHtml5VideoPlaying() || this.autoplay == 'true';

      this.videoContainer.remove();
      this.appendCurrentVideoContainer();

      if (shouldKeepContainerClosed) {
        this.videoContainer?.classList.add('close');
        return;
      }

      if (this.type == 'video' && shouldResumeVideo) {
        this.videoContainer?.querySelectorAll('.yg-video-iframe').forEach((video) => video.play());
      } else if (this.type == 'video') {
        this.videoContainer?.querySelectorAll('.yg-video-iframe').forEach((video) => video.pause());
      }
    }

    appendCurrentVideoContainer() {
      if (!this.template) return;

      this.appendChild(this.getCurrentVideoFragment());
    }

    getCurrentVideoTemplate() {
      const template = document.createElement('template');

      template.content.appendChild(this.getCurrentVideoFragment());

      return template;
    }

    getCurrentVideoFragment() {
      const fragment = this.template?.content.cloneNode(true) || document.createDocumentFragment();
      const videoContainer = fragment.querySelector('.yg-video-iframe-container');

      this.keepCurrentVideoVariant(videoContainer);

      return fragment;
    }

    keepCurrentVideoVariant(videoContainer) {
      if (!videoContainer) return;

      const videos = Array.from(videoContainer.querySelectorAll('.yg-video-iframe'));
      const hasMobileVideo = videos.some((video) => video.classList.contains('hide-pc'));
      const hasDesktopVideo = videos.some((video) => video.classList.contains('hide-mobile'));

      videos.forEach((video) => {
        const isMobileVideo = video.classList.contains('hide-pc');
        const isDesktopVideo = video.classList.contains('hide-mobile');

        if (this.isMobileViewport && hasMobileVideo && isDesktopVideo) {
          video.remove();
        }

        if (!this.isMobileViewport && hasDesktopVideo && isMobileVideo) {
          video.remove();
        }
      });
    }

    hasCurrentVideoVariant(videoContainer) {
      if (!videoContainer) return false;

      const videos = Array.from(videoContainer.querySelectorAll('.yg-video-iframe'));
      const templateVideos = Array.from(this.template?.content.querySelectorAll('.yg-video-iframe') || []);
      const templateHasMobileVideo = templateVideos.some((video) => video.classList.contains('hide-pc'));
      const templateHasDesktopVideo = templateVideos.some((video) => !video.classList.contains('hide-pc'));

      if (this.isMobileViewport && templateHasMobileVideo) {
        return videos.some((video) => video.classList.contains('hide-pc'));
      }

      if (!this.isMobileViewport && templateHasDesktopVideo) {
        return videos.some((video) => !video.classList.contains('hide-pc'));
      }

      return videos.length > 0;
    }

    isCurrentHtml5VideoPlaying() {
      if (this.type != 'video' || !this.videoContainer) return false;

      return Array.from(this.videoContainer.querySelectorAll('.yg-video-iframe')).some(
        (video) => !video.paused && !video.ended
      );
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState('pause');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach((video) => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState(state = 'play') {
      if (state == 'pause') {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == 'play') {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
